// hooks/district/context.js
import { createContext, useContext, useReducer } from 'react';
import { districtReducer, initialState } from './reducer';

const DistrictContext = createContext();

export const DistrictProvider = ({ children }) => {
    const [state, dispatch] = useReducer(districtReducer, initialState);

    return <DistrictContext.Provider value={[state, dispatch]}>{children}</DistrictContext.Provider>;
};

export const useDistrictContext = () => {
    const context = useContext(DistrictContext);
    if (!context) {
        throw new Error('useDistrcitContext must be used within a DistrictProvider');
    }
    return context;
};
